import { COLORS } from 'helpers/globals'

export default {
  container: {
    background: 'white',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    background: COLORS.primary,
    color: 'white',
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: '500'
  },
  searchWrapper: {
    padding: '.5rem',
    position: 'relative'
  },
  searchInput: {
    paddingLeft: '2.5rem !important'
  },
  searchIcon: {
    position: 'absolute',
    left: '1rem',
    top: '1.1rem'
  },
  loading: {
    margin: 'auto',
    textAlign: 'center',
    fontSize: '3rem',
    color: COLORS.secondary,
    fontWeight: '400',
    display: 'flex',
    flexDirection: 'column'
  },
  loadingButton: {
    margin: 'auto auto 1rem auto',
    fontSize: '4rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileStart/LocationSearch/style.js